// Module
var code = "<h1 id=\"理事会\">理事会</h1> <p>理事会由一组股东投票通过的理事会成员组成，理事会成员的职责在于设定系统运行参数。其中包括：</p> <ul> <li>转账及交易手续费</li> <li>区块链参数，比如区块大小，区块生成时间间隔，等等</li> <li>推荐及冻结/解冻参数，比如奖励返现比例和冻结时间等</li> </ul> ";
// Exports
export default code;